/**
 * COMMENT S'ÉCRIT UNE DATE DANS LE MODULE DES EXPORTS COMPTABLES.
 *
 * Un seul endroit, parce que deux écrans affichent le MÊME champ
 * (`exports_comptables.genere_at`) : la liste des clôtures et l'écran
 * d'initialisation. Ils le formataient chacun à leur manière, et l'un des deux
 * avait tort (audit du 14/10/2026) : découper la chaîne ISO (`slice(0, 10)`)
 * lit le jour en temps UNIVERSEL, donc une opération lancée après 22 h à Paris
 * s'affichait à la veille — et les deux écrans annonçaient deux dates
 * différentes pour la même opération.
 *
 * L'HEURE est affichée, et ce n'est pas du détail : sur une opération qui n'a
 * lieu qu'une fois, « le 14/10 à 23:40 » lève l'ambiguïté que « le 14/10 »
 * laisse entière.
 */

/** « 2026-10-14T21:40:12.000Z » → « 14/10/2026 23:40 » (heure de Paris). */
export function quandCompta(iso: string | null | undefined): string {
  if (!iso) return '—';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleString('fr-FR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    timeZone: 'Europe/Paris',
  });
}
